import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePackageTicketMutationVariables = GraphQLTypes.Exact<{
  packageId: GraphQLTypes.Scalars['String'];
  id: GraphQLTypes.Scalars['String'];
  packageTicketInput: GraphQLTypes.UpdateTicketPackageInput;
}>;


export type UpdatePackageTicketMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'updatePackageTicket'>
);


export const UpdatePackageTicketDocument = /*#__PURE__*/ gql`
    mutation updatePackageTicket($packageId: String!, $id: String!, $packageTicketInput: UpdateTicketPackageInput!) {
  updatePackageTicket(
    packageId: $packageId
    id: $id
    packageTicketInput: $packageTicketInput
  )
}
    `;

/**
 * __useUpdatePackageTicketMutation__
 *
 * To run a mutation, you first call `useUpdatePackageTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageTicketMutation, { data, loading, error }] = useUpdatePackageTicketMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      id: // value for 'id'
 *      packageTicketInput: // value for 'packageTicketInput'
 *   },
 * });
 */
export function useUpdatePackageTicketMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackageTicketMutationResult, UpdatePackageTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackageTicketMutationResult, UpdatePackageTicketMutationVariables>(UpdatePackageTicketDocument, options);
      }
export type UpdatePackageTicketMutationHookResult = ReturnType<typeof useUpdatePackageTicketMutation>;